var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperHighDemandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44098 1.88197C3.86446 1.67023 4.37123 1.71593 4.75 2.00001L6.66667 3.43751L8.58333 2.00001C9.02778 1.66667 9.63889 1.66667 10.0833 2.00001L12 3.43751L13.9167 2.00001C14.3611 1.66667 14.9722 1.66667 15.4167 2.00001L17.3333 3.43751L19.25 2.00001C19.6288 1.71593 20.1355 1.67023 20.559 1.88197C20.9825 2.09371 21.25 2.52654 21.25 3.00001V16C21.25 18.8995 18.8995 21.25 16 21.25H8C5.10051 21.25 2.75 18.8995 2.75 16V3.00001C2.75 2.52654 3.0175 2.09371 3.44098 1.88197ZM5.25 5.50001V16C5.25 17.5188 6.48122 18.75 8 18.75H16C17.5188 18.75 18.75 17.5188 18.75 16V5.50001L18.0833 6.00001C17.6389 6.33334 17.0278 6.33334 16.5833 6.00001L14.6667 4.56251L12.75 6.00001C12.3056 6.33334 11.6944 6.33334 11.25 6.00001L9.33333 4.56251L7.41667 6.00001C6.97222 6.33334 6.36111 6.33334 5.91667 6.00001L5.25 5.50001Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.15385C11 8.51659 11.4477 8 12 8C12.5523 8 13 8.51659 13 9.15385L13 12.8462C13 13.4834 12.5523 14 12 14C11.4477 14 11 13.4834 11 12.8462L11 9.15385ZM11.9995 15C12.5515 15 12.9995 15.4542 12.9995 16.004C12.9995 16.5538 12.5515 17 11.9995 17C11.4475 17 10.9995 16.5538 10.9995 16.004L10.9995 15.9894C10.9995 15.4396 11.4475 15 11.9995 15Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperHighDemandIcon);
export default __webpack_public_path__ + "static/media/superHighDemandIcon.44fe8d38.svg";
export { ForwardRef as ReactComponent };